import { Apple, Dumbbell, Calendar, Users } from 'lucide-react';
import { useRevealOnScroll } from '../../ui';

const features = [
  {
    icon: Apple,
    title: 'Easy Food & Workout Logging',
    description: 'Track meals, workouts, and questions in normal language, then switch to faster guided inputs when taps are easier than typing.',
  },
  {
    icon: Dumbbell,
    title: 'Structured Training Sessions',
    description: 'Move through sets quickly during a workout without losing notes, effort, or what to change next time.',
  },
  {
    icon: Calendar,
    title: 'Plans That Bend With Life',
    description: 'Training, food, and check-ins can adapt around travel, busy weeks, and low-energy days instead of assuming every week is ideal.',
  },
  {
    icon: Users,
    title: 'Shared Progress',
    description: 'Keep workouts, nutrition, questions, and adjustments in one place so you and your coach stay aligned.',
  },
];

export function Features() {
  const gridRef = useRevealOnScroll<HTMLDivElement>();
  return (
    <section id="features" className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="section-eyebrow">What You Can Do</p>
          <h2 className="section-title">
            Plan, track, and adjust in one place
          </h2>
          <p className="section-copy mx-auto">
            TrackWithAI is built for the messy middle: deciding what to do, logging what happened, and tightening the next week without starting over from scratch.
          </p>
        </div>

        <div
          ref={gridRef}
          className="reveal-on-scroll reveal-stagger grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4"
        >
          {features.map((feature) => (
            <div
              key={feature.title}
              className="app-mini-panel h-full"
            >
              <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-[var(--color-brand-faint)] text-[var(--color-brand)]">
                <feature.icon className="w-6 h-6" />
              </div>
              <h3 className="mb-2 text-lg font-semibold text-[var(--color-ink)]">
                {feature.title}
              </h3>
              <p className="text-[var(--color-muted)]">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
